import React from 'react'
import { MyUserGroup } from '@Scenes/RightsholderScene/RightsholderMaintenanceUserPermissionsProfile'
import { UserInfo } from '@Entities/user/user'
import EditActionsGroupRow from '@Scenes/RightsholderScene/RightsholderMaintenanceUserPermissionsProfile/UserPermissionsModal/ChangePermissionPopup/EditActionsGroupRow'

interface EditActionsGroupsTableProps {
    editActionsGroups: MyUserGroup[]
    rightsholderUser: UserInfo
}

const EditActionsGroupsTable = (props: EditActionsGroupsTableProps) => {
    const { rightsholderUser, editActionsGroups } = props
    return (
        <div className="actions-container">
            {editActionsGroups.map((myUserGroup: MyUserGroup) => (
                <EditActionsGroupRow
                    myUserGroup={myUserGroup}
                    rightsholderUser={rightsholderUser}
                    key={myUserGroup.name}
                />
            ))}
        </div>
    )
}

export default EditActionsGroupsTable
